var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewRankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_17826_85875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 68,
    height: 68,
    rx: 15,
    fill: "url(#paint0_linear_17826_85875)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4543 46.8468L54.7046 44.528C54.8365 43.2904 54.9249 42.4744 54.8555 41.9604H54.88C55.3455 41.9602 55.797 41.8009 56.1595 41.5088C56.5219 41.2167 56.7736 40.8095 56.8727 40.3546C56.9718 39.8998 56.9124 39.4247 56.7042 39.0083C56.4961 38.5919 56.1518 38.2592 55.7285 38.0655C55.3053 37.8717 54.8284 37.8285 54.3773 37.9431C53.9261 38.0577 53.5276 38.3232 53.2481 38.6955C52.9686 39.0677 52.8248 39.5244 52.8406 39.9896C52.8565 40.4549 53.0309 40.9007 53.335 41.2532C52.8917 41.5265 52.3123 42.1045 51.4406 42.9736C50.7674 43.644 50.4314 43.9786 50.0561 44.0303C49.8481 44.059 49.6362 44.0293 49.4441 43.9446C49.0986 43.7923 48.8674 43.3788 48.4064 42.5506L45.972 38.1864C45.6878 37.6764 45.4498 37.248 45.2349 36.9052C45.7792 36.6279 46.2144 36.1753 46.4702 35.6205C46.7259 35.0656 46.7875 34.4408 46.6448 33.8467C46.5022 33.2527 46.1637 32.7239 45.6839 32.3457C45.2041 31.9674 44.611 31.7617 44 31.7617C43.389 31.7617 42.7959 31.9674 42.3161 32.3457C41.8363 32.7239 41.4978 33.2527 41.3552 33.8467C41.2125 34.4408 41.2741 35.0656 41.5298 35.6205C41.7856 36.1753 42.2208 36.6279 42.7651 36.9052C42.5502 37.2493 42.3122 37.6764 42.0266 38.1864L39.5936 42.5506C39.1312 43.3788 38.9 43.7923 38.5546 43.9446C38.3624 44.0293 38.1506 44.059 37.9426 44.0303C37.5686 43.9786 37.2326 43.644 36.5594 42.9736C35.6877 42.1045 35.1083 41.5265 34.665 41.2532C34.9691 40.9007 35.1436 40.4549 35.1594 39.9896C35.1752 39.5244 35.0314 39.0677 34.7519 38.6955C34.4724 38.3232 34.0739 38.0577 33.6227 37.9431C33.1716 37.8285 32.6947 37.8717 32.2715 38.0655C31.8482 38.2592 31.5039 38.5919 31.2958 39.0083C31.0877 39.4247 31.0282 39.8998 31.1273 40.3546C31.2264 40.8095 31.4781 41.2167 31.8405 41.5088C32.203 41.8009 32.6545 41.9602 33.12 41.9604H33.1445C33.0751 42.4744 33.1635 43.2918 33.2954 44.528L33.5457 46.8468C33.6844 48.1334 33.7986 49.3588 33.9401 50.4604H54.0599C54.2014 49.3588 54.3156 48.1348 54.4543 46.8468ZM42.5203 56.2404H45.4797C49.3366 56.2404 51.2651 56.2404 52.5517 55.0884C53.1134 54.5852 53.4683 53.6795 53.7254 52.5004H34.2746C34.5317 53.6795 34.8866 54.5866 35.4483 55.0884C36.7349 56.2404 38.6634 56.2404 42.5203 56.2404Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_17826_85875",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.672092 0 0 0 0 0.759491 0 0 0 0 0.832324 0 0 0 0.599836 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17826_85875"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_17826_85875",
    result: "effect2_dropShadow_17826_85875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17826_85875",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17826_85875",
    x1: 48.08,
    y1: 78,
    x2: 48.08,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED480"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewRankIcon);
export default __webpack_public_path__ + "static/media/overview-rank-icon.e355aaa436662f06427218b8f915281e.svg";
export { ForwardRef as ReactComponent };